export const KB = 1024;
export const MB = KB * 1024;
